import React from "react";
import { zl, zaokr } from "../../../functions/utilities.js";

const MieszkaniecDaneWodaRozliczenieKoszt = props => {
    
    const {  procent, rozliczenieWodyAkt } = props;
    
    return (
        <div className="koszt">
            <div className="naglowek">Koszt pobranej wody</div>
            
            <div className="kalkulacje">
                <table>
                    <tbody>
                        <tr>
                            <td style={{textAlign: "left", paddingLeft: "15px"}}>
                                Zimna woda:
                            </td>
                            <td>
                                {`(${procent?.zuzycieMieszkancaZimna} m³ + ${procent?.zuzycieMieszkancaCiepla} m³)`}
                            </td>
                            <td>
                                x
                            </td>
                            <td>
                                {`${zl(rozliczenieWodyAkt?.metr_3_zimnej)}`}
                            </td>
                            <td>
                                =
                            </td>
                            <td>
                                {`${zl(procent.kosztZimnej)}`}
                            </td>
                        </tr>
                        <tr>
                            <td style={{textAlign: "left", paddingLeft: "15px"}}>
                                Koszt abonamentu:
                            </td>
                            <td>
                                {`${procent?.metraz} m²`}
                            </td>
                            <td>
                                x
                            </td>
                            <td>
                                {`${zl(rozliczenieWodyAkt?.abonament_msc)} x ${rozliczenieWodyAkt?.liczbaMsc} msc.`}
                            </td>
                            <td>
                                =
                            </td>
                            <td>
                                {`${zl(procent?.abonament)}`}
                            </td>                            
                        </tr>
                        <tr>
                            <td style={{textAlign: "left", paddingLeft: "15px"}}>
                                Podgrzanie wody:
                            </td>
                            <td>
                                {`${procent?.zuzycieMieszkancaCiepla} m³`}
                            </td>
                            <td>
                                x
                            </td>
                            <td>
                                {`${zl(rozliczenieWodyAkt?.kosztPodgrzaniaCieplej)}`}
                            </td>
                            <td>
                                =
                            </td>
                            <td>
                                {`${zl(procent?.podgrzanieWody)}`}
                            </td>                            
                        </tr>                        
                        <tr>
                            <td style={{textAlign: "left", paddingLeft: "15px"}}>
                                Razem koszt zużycia wody:
                            </td>
                            <td colSpan={3}>
                                {`${zl(procent?.kosztZimnej)} + ${zl(procent?.abonament)} + ${ zl( procent?.podgrzanieWody ) }`}
                            </td>
                            <td>
                                =
                            </td>
                            <td>
                                <span style={{fontWeight: "600"}}>
                                    {zl(procent?.razemZwCwAbo)}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    )
}

export default MieszkaniecDaneWodaRozliczenieKoszt;